export default __webpack_public_path__ + "locales/sr-Latn-RS/DeleteThirdPartyDialog.json?hash=63821bfe814ede64d7027815fe6a2991";